import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

export const useProductManagement = (refetch: () => void) => {
  const [isAddProductDialogOpen, setIsAddProductDialogOpen] = useState(false);
  const [isDeleteProductDialogOpen, setIsDeleteProductDialogOpen] = useState(false);

  const handleAddProduct = async (product: any) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error("Vous devez être connecté");
        return;
      }

      const { data: ownerData } = await supabase
        .from('owner_data')
        .select('business_type_id')
        .eq('owner_id', user.id)
        .single();

      if (!ownerData) {
        toast.error("Données propriétaire non trouvées");
        return;
      }

      const { data: businessStock } = await supabase
        .from('business_stocks')
        .select('id')
        .eq('business_id', ownerData.business_type_id)
        .single();

      if (!businessStock) {
        toast.error("Stock non trouvé");
        return;
      }

      const { error: insertError } = await supabase
        .from('stock_items')
        .insert({
          stock_id: businessStock.id,
          data: {
            name: product.name,
            unit: product.unit,
            price: product.price,
            minQuantity: product.minQuantity,
            status: product.status
          },
          quantity: product.quantity
        });

      if (insertError) throw insertError;

      toast.success("Produit ajouté avec succès");
      setIsAddProductDialogOpen(false);
      refetch();
    } catch (error: any) {
      console.error("Erreur lors de l'ajout du produit:", error);
      toast.error(error.message || "Erreur lors de l'ajout du produit");
    }
  };

  const handleDeleteProduct = async (productId: string) => {
    try {
      const { error } = await supabase
        .from('stock_items')
        .delete()
        .eq('id', productId);

      if (error) throw error;

      toast.success("Produit supprimé avec succès");
      refetch();
    } catch (error: any) {
      console.error("Erreur lors de la suppression:", error);
      toast.error("Erreur lors de la suppression du produit");
    }
  };

  return {
    isAddProductDialogOpen,
    setIsAddProductDialogOpen,
    isDeleteProductDialogOpen,
    setIsDeleteProductDialogOpen,
    handleAddProduct,
    handleDeleteProduct,
  };
};